export default "__VITE_ASSET__De9TrdHI__"